namespace TotalPoll {
    import Service = TotalCore.Common.Service;

    @Service('services.totalpoll')
    export class RepositoryService {
        public resource;

        constructor($resource, prefix, ajaxEndpoint) {
            this.resource = $resource(ajaxEndpoint, {}, {
                saveOptions: {
                    method: 'POST',
                    params: {action: `${prefix}_options_save_options`}
                },
                migratePolls: {
                    method: 'POST',
                    params: {action: `${prefix}_options_migrate_polls`}
                },
                purge: {
                    method: 'POST',
                    params: {action: `${prefix}_options_purge`},
                }
            });

            return this;
        }

        getDebugInformation() {
            return window['TotalPollDebugInformation'] || {};
        }

        getExpressions() {
            return window['TotalPollExpressions'] || {};
        }

        getMigrationPlugins() {
            return window['TotalPollMigrationPlugins'] || {};
        }

        getOptions() {
            return window['TotalPollOptions'] || {};
        }

        postMigratePolls(plugin) {
            return this.resource.migratePolls({plugin: plugin}).$promise;
        }

        postOptions(options) {
            return this.resource.saveOptions({options: options}).$promise;
        }

        postPurge(type) {
            return this.resource.purge({type: type}).$promise;
        }
    }
}